import { currencyToTopPayRegion, topPayAmountDecimals } from './toppay-region.js';

function toPositiveNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/**
 * Fiat input → credit USD (full precision; display may truncate 2dp).
 */
export function fiatToCreditUsd(fiatAmount, fiatPerUsd, decimals = 0) {
  const v =
    decimals > 0
      ? Number(parseFloat(fiatAmount).toFixed(decimals))
      : Math.round(toPositiveNumber(fiatAmount));
  const rate = toPositiveNumber(fiatPerUsd);
  if (!v || !rate) return 0;
  return Number((v / rate).toFixed(8));
}

/** @deprecated use fiatToCreditUsd */
export function vndToCreditUsd(vnd, vndPerUsd) {
  return fiatToCreditUsd(vnd, vndPerUsd, 0);
}

/** USD preview → channel fiat (ceil for VND, round 2dp for LATAM). */
export function creditUsdToPayFiat(usd, fiatPerUsd, regionOrCurrency) {
  const u = toPositiveNumber(usd);
  const rate = toPositiveNumber(fiatPerUsd);
  if (!u || !rate) return 0;
  const decimals = topPayAmountDecimals(regionOrCurrency);
  if (decimals === 0) return Math.ceil(u * rate);
  return Number((u * rate).toFixed(2));
}

/** @deprecated use creditUsdToPayFiat */
export function creditUsdToPayVnd(usd, vndPerUsd) {
  return creditUsdToPayFiat(usd, vndPerUsd, 'VN');
}

/**
 * Create TopPay order body. Local cash page should pass payMoney (channel fiat).
 */
export function buildTopPayCreateOrderPayload({
  region,
  creditUsd,
  method,
  payMoney,
  payMoneyVnd,
} = {}) {
  const usd = toPositiveNumber(creditUsd);
  const payload = {
    region:
      String(region ?? 'VN')
        .trim()
        .toUpperCase() || 'VN',
    creditUsd: usd ? Number(usd.toFixed(8)) : creditUsd,
    method: String(method ?? '').trim(),
  };
  // PH Global：纯收银台，不传 method（用户在 TopPay H5 自选 GCash/Maya）
  if (payload.region === 'PH') {
    payload.method = '';
  }
  const rawPay = payMoney != null ? payMoney : payMoneyVnd;
  const pay = Number(rawPay);
  if (!Number.isFinite(pay) || pay <= 0) return payload;
  payload.payMoney = pay;
  if (payload.region === 'VN') payload.payMoneyVnd = Math.round(pay);
  return payload;
}

/**
 * 当前法币对应 TopPay 区的最低支付额。必须按币种读 regions，不能用 activeRegion
 * （切币后 watch 还没跑时，activeRegion 仍是上一国，会把 VND 最低额 125000 抬到 USD 上）。
 */
export function resolveTopPayMinPayMoney(regions, currency, fallbackMinUsd = 5) {
  const region = currencyToTopPayRegion(currency);
  if (!region) return 0;
  const cfg = regions?.[region];
  const fromApi = Number(cfg?.minPayMoney);
  if (Number.isFinite(fromApi) && fromApi > 0) return fromApi;
  const rate = Number(cfg?.fiatPerUsd);
  if (Number.isFinite(rate) && rate > 0) {
    return creditUsdToPayFiat(fallbackMinUsd, rate, region);
  }
  return 0;
}
